import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Header } from 'semantic-ui-react';

import { CampaignList } from '../../screens';
import * as AppActions from '../../actions';
import { getAccount } from "../../fbApi/Account";

class AdAccountDetail extends Component {
  state = {
    account: null,
    token: this.props.getFbToken(),
  };

  componentDidMount() {
    this.props.setSectionTitle('Account');
    this.getAdAccount();
  }

  getAdAccount = async () => {
    const { match } = this.props;
    try {
      const accountId = match.params.id;
      const account = await getAccount(accountId, this.state.token);
      this.setState({ account });
    } catch (error) {
      alert(error.message);
    }
  };

  renderAdAccount = () => {
    const { account } = this.state;
    return this.state.account
      ? <Header>
        {account.name}
      </Header>
      : null;
  };

  renderCampaign = () => {
    const { match } = this.props;
    const accountId = match.params.id;
    return accountId ?  <CampaignList accountId={accountId} token={this.state.token} /> : null;
  };

  render() {
    return (
      <div className="container">
        {this.renderAdAccount()}
        {this.renderCampaign()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdAccountDetail);



// WEBPACK FOOTER //
// ./src/screens/AdAccount/AdAccountDetail.js